<template>
    <!-- 活动-司机加速包 原超必赔 -->
    <div class="container delay">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">单号:</span>
                        <!-- 搜索单号 -->
                        <el-input
                            v-model="search_data.billno"
                            placeholder="请输入单号"
                            class="handle-input mr10"
                            @keyup.enter.native="searchGetDelayReductionRecord"
                        ></el-input>
                    </el-col>
                    <el-col :span="12">
                        <span class="title">日期:</span>

                        <el-date-picker
                            v-model="search_time"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="timeChange"
                            style="width: 350px"
                        >
                        </el-date-picker>
                    </el-col>
                </el-row>

                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">理赔状态:</span>
                        <!-- 理赔状态 -->
                        <el-select v-model="search_data.status" style="width: 200px" clearable>
                            <el-option label="已购买" value="0"> </el-option>
                            <el-option label="有延误" value="1"> </el-option>
                            <el-option label="已理赔" value="2"> </el-option>
                            <el-option label="无需赔" value="3"> </el-option>
                        </el-select>
                    </el-col>

                    <!--                    <el-col :span="12">-->
                    <!--                        <span class="title">支付状态:</span>-->
                    <!--                        &lt;!&ndash; 理赔状态 &ndash;&gt;-->
                    <!--                        <el-select v-model="search_data.pay_status" style="width: 200px" clearable>-->
                    <!--                            <el-option-->
                    <!--                                    label="待支付"-->
                    <!--                                    value="1">-->
                    <!--                            </el-option>-->
                    <!--                            <el-option-->
                    <!--                                    label="已支付"-->
                    <!--                                    value="2">-->
                    <!--                            </el-option>-->
                    <!--                        </el-select>-->

                    <!--                    </el-col>-->
                </el-row>
            </div>
            <!-- <el-button @click="add_isShow = !add_isShow">减免配置</el-button> -->

            <div style="display: flex; justify-content: space-between">
                <div>
                    <el-button type="primary" icon="el-icon-search" @click="searchGetDelayReductionRecord">搜索</el-button>
                    <el-button v-if="loading" icon="el-icon-loading" disabled></el-button>
                    <el-button icon="el-icon-setting" @click="toExport" v-else>导出</el-button>
                    <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
                </div>
                <div v-if="delay">
                    <a style="margin: 0 10px">司机加速包购买金额:{{ result_data.data.delay_fee }}</a>
                    <a style="margin: 0 10px">司机加速包理赔金额:{{ result_data.data.deduction_amount }}</a>
                </div>
            </div>
        </div>
        <el-table :data="tableData" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column label="城市" prop="city_name"> </el-table-column>
            <el-table-column label="客户手机号" prop="consumer_phone"> </el-table-column>

            <el-table-column label="司机姓名" prop="driver_name"> </el-table-column>

            <el-table-column label="接单时间" prop="take_time_stamp"> </el-table-column>

            <el-table-column label="到达起点时间" prop="arrive_time_stamp"> </el-table-column>

            <el-table-column label="晚点时长（分钟）" prop="delay_duration"> </el-table-column>

            <el-table-column label="减免金额" prop="deduction_amount"> </el-table-column>

            <!-- <el-table-column label="规则" prop="rule"> </el-table-column> -->

            <el-table-column label="支付时间" prop="pay_time"> </el-table-column>

            <el-table-column label="单号" prop="billno"> </el-table-column>
            <el-table-column label="理赔状态" prop="status_des"> </el-table-column>

            <el-table-column label="操作" width="320" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="rulesBtn(scope.row)">规则 </el-button>
                    <el-button type="primary" size="mini" @click="toOrderDetails(scope.row)">订单详情 </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 添加组件 -->
        <getDelayReductionConf :isShow="add_isShow" @onSubmit="searchGetDelayReductionRecord"></getDelayReductionConf>

        <!-- 查看组件 -->
        <viewRoute
            :history="history"
            :isShow="viewRoute_show"
            :data="toDispatch_data"
            :status="order_status"
            :showConsumer="true"
        ></viewRoute>
        <!-- 列表规则组件 -->
        <getRulesList :isShow="rule_isShow" :data="rules_data" @onSubmit="searchGetDelayReductionRecord"></getRulesList>
    </div>
</template>

<script>
var _this;
import getDelayReductionConf from './getDelayReductionConf.vue';
import viewRoute from '@/components/page/orderManagement/substituteDrivingOrder/viewRoute.vue';
import getRulesList from './getRulesList.vue'; //订单路线

export default {
    components: {
        getDelayReductionConf,
        viewRoute,
        getRulesList
    },
    data() {
        return {
            delay: false,
            rules_data: {},
            rule_isShow: false,

            viewRoute_show: false,
            history: '',
            order_status: '',
            toDispatch_data: '',

            add_isShow: false,
            search_time: '',
            // 存放表格数据
            tableData: [],

            excelData: [],

            loading: false,

            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10,
                time_stamp: '',
                billno: '',
                status: ''
                // pay_status:''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;

        _this.searchGetDelayReductionRecord();
    },

    methods: {
        rulesBtn(scope) {
            _this.rules_data = scope;
            _this.rule_isShow = !_this.rule_isShow;
        },
        toOrderDetails(row) {
            _this.toDispatch_data = row.order_code;
            // _this.toDispatch_data.city_code = row.city_code;
            // _this.toDispatch_data.city_tag = row.city_tag;

            let httpUrl = '';
            if (row.is_history == '1') {
                _this.history = true;
                httpUrl = '/order/getOrderDetailsHistory';
            } else if (row.is_history == '0') {
                // _this.history = 'nomarlNew';  // super端
                // httpUrl = '/order/getOrderDetailsNew'; //super端
                _this.history = false;
                httpUrl = '/order/getOrderDetails';
            }
            // _this.viewRoute_show = !_this.viewRoute_show;

            _this
                .$post(httpUrl, {
                    order_code: row.order_code,
                    coordinate: '1',
                    synchronization: '1',
                    order_track: '1',
                    order_difference: '1'
                    // city_code: row.city_code,
                    // city_tag: row.city_tag
                })
                .then((res) => {
                    _this.order_status = res.data.order_details.status.val; // 获取_this.order_status
                    _this.viewRoute_show = !_this.viewRoute_show;
                });
        },

        // 导出
        toExport() {
            _this.search_data.page = 1;
            _this.loading = true;
            _this.getExcelData();
        },
        // 导出任务创建
        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = [
                '城市',

                '客户手机号',
                '接单时间',
                '司机姓名',
                '到达起点时间',
                '晚点时长（分钟）',
                '减免金额',
                // '规则',
                '支付时间',
                '单号',
                '理赔状态'
            ];
            const filterVal = [
                'city',

                'consumer_phone',
                'take_time_stamp',
                'driver_name',
                'arrive_time_stamp',
                'delay_duration',
                'deduction_amount',
                // 'rule',
                'pay_time',
                'billno',
                'status_des'
            ];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, '司机加速包表格');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },

        getExcelData() {
            _this
                .$post('/delayreduction/getDelayReductionRecord', _this.search_data)
                .then((res) => {
                    _this.loading = true;

                    if (this.$route.path == '/delayReduction') {
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.list.length; i++) {
                            _this.excelData.push({
                                city: res.data.list[i].city_name,

                                consumer_phone: res.data.list[i].consumer_phone,
                                take_time_stamp: res.data.list[i].take_time_stamp,
                                driver_name: res.data.list[i].driver_name,
                                arrive_time_stamp: res.data.list[i].arrive_time_stamp,
                                delay_duration: res.data.list[i].delay_duration,
                                deduction_amount: res.data.list[i].deduction_amount,

                                // rule: res.data.list[i].rule,
                                pay_time: res.data.list[i].pay_time,
                                billno: res.data.list[i].billno,
                                status_des: res.data.list[i].status_des
                            });
                        }

                        if (_this.search_data.page * _this.search_data.limit < res.count) {
                            _this.search_data.page = _this.search_data.page + 1;

                            _this.getExcelData();
                        } else {
                            // console.log(_this.excelData);

                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.loading = false;
                        }
                    } else {
                        _this.loading = false;
                    }
                })
                .catch((err) => {
                    _this.load = false;
                });
        },

        timeChange(val) {
            console.log(val);

            if (val != null) {
                _this.search_data.time_stamp = JSON.stringify(['between', ..._this.search_time]);
            } else {
                _this.search_data.time_stamp = '';
            }
        },

        searchGetDelayReductionRecord() {
            _this.search_data.page = 1;
            _this.getDelayReductionRecord();
        },

        getDelayReductionRecord() {
            _this
                .$post('/delayreduction/getDelayReductionRecord', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data.list;
                    _this.result_data = res;
                    _this.delay = true;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.getDelayReductionRecord();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
<style>
.delay head-search .el-input--small .el-input__inner {
    width: 350px;
}
</style>
